module.exports = __webpack_public_path__ + "static/media/ImpactStoryLogoTiktok.98ac5e2d.png";